<template>
  <div class="form-group options-list-tab">
    <div class="form-label">Choices</div>
    <!-- If editing, show the search bar + dropdown -->
    <input ref="input" type="text" class="form-control" :value="options.length + ' values'"
      @mousedown.prevent.stop="beginEditing">
    <div class="dropdown-list" v-if="editing" ref="optionsList">
      <textarea v-model="optionsString" placeholder="Enter options (one per line)" @input="resizeTextArea"
        :disabled="locked" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'OptionsListTab',
  props: {
    options: Array,
    locked: Boolean
  },
  data() {
    return {
      editing: false,
      optionsString: ''
    }
  },
  mounted() {
    window.addEventListener('mousedown', this.onMouseDown);
  },
  unmounted() {
    window.removeEventListener('mousedown', this.onMouseDown);
  },
  watch: {
    options: {
      handler() {
        this.optionsString = this.options.join('\n');
      },
      immediate: true
    }
  },
  methods: {
    beginEditing() {
      if (this.editing) return false;

      setTimeout(() => {
        this.editing = true;

        this.$nextTick(this.resizeTextArea);
      })
    },
    onMouseDown(event) {
      const optionsList = this.$refs.optionsList;
      if (this.editing && optionsList != null) {
        if (!optionsList.contains(event.target)) {
          this.editing = false;
          this.updateOptions();
        }
      }
    },
    updateOptions() {
      const options = this.optionsString.split('\n').map(s => s.trim())
      this.$emit('updateOptions', options);
    },
    resizeTextArea() {
      const textarea = this.$el.querySelector('textarea');
      if (!textarea);
      textarea.style.height = `0px`;
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  },
  emits: ['updateOptions']
}
</script>

<style scoped>
.form-group {
  position: relative;
}

.dropdown-list {
  left: 0px;
  top: 100%;
  position: absolute;
  background: #FFF;
  box-shadow: 0px 0px 8px #00000044;
  width: 100%;
  max-height: 300px;
  overflow: auto;
  z-index: 1000;
}

.dropdown-item-section:not(:first-child) {
  margin-top: 20px;
}

.dropdown-item-option input {
  width: 100%;
  padding: 10px;
  border: none;
  border-bottom: 1px solid #CCC;
  font-size: 16px;
}

.dropdown-item-option span {
  margin-left: 10px;
}

.dropdown-item-option:hover {
  background: #eef3ff;
  cursor: pointer;
}

.form-control {
  cursor: pointer;
  background: #F5F5F5;
  border-bottom: 1px solid #DDD;
}

textarea {
  padding: 0;
  width: 100%;
  font-size: 16px;
  padding: 10px;
  border: none;
  text-wrap: nowrap;
  resize: none;
  display: block;
  line-height: 1.5;
}
</style>